// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
//Last ADD : NEW'
// MODFIED DATA : 18-08-2025
import { docodeHexResponse } from '../../_common/common.utils';
import AutoLoanCollectionActionTypes from './auto-loan-collection-report.types';
const INITIAL_STATE = {
	getAutoLoanCollectionDetailsResp: null,
	getAutoLoanCollectionDetailsArr: [],

	getExportAutoLoanCollectionDetailsResp: null,
	revertAutoLoanCollectionDetailsResp: null,
};

const autoLoanCollectionReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*************** Get Auto Loan Collection Details Start ******************/
		case AutoLoanCollectionActionTypes.GET_AUTO_LOAN_REPORT_DETAILS_SUCCESS:
			return {
				...state,
				getAutoLoanCollectionDetailsResp: action.payload,
				getAutoLoanCollectionDetailsArr: docodeHexResponse(
					action.payload,
					'GetAutoLoanCollectionReportKey',
				),
			};

		case AutoLoanCollectionActionTypes.GET_AUTO_LOAN_REPORT_DETAILS_FAILURE:
			return {
				...state,
				getAutoLoanCollectionDetailsResp: action.payload,
				getAutoLoanCollectionDetailsArr: [],
			};

		case AutoLoanCollectionActionTypes.GET_AUTO_LOAN_REPORT_DETAILS_RESPONSE_CHANGED:
			return { ...state, getAutoLoanCollectionDetailsResp: null };
		/*************** Get Auto Loan Collection Details End ******************/
		default:
			return state;
	}
};

export default autoLoanCollectionReportReducer;
